import React from 'react';
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGoogle } from '@fortawesome/free-brands-svg-icons';
import { loginWithProvider } from './LoginManager';
import toast from 'react-hot-toast';

const SocialMedia = ({ handleResponse }) => {

    const googleProvider = new firebase.auth.GoogleAuthProvider();

    const handleSignIn = (provider) => {
        const loading = toast.loading('Please wait...');

        loginWithProvider(provider)
            .then(res => {
                toast.dismiss(loading);

                if (res.error) {
                    toast.error(res.error);
                    return;
                }

                handleResponse(res);
                toast.success('Login successful');
            });
    };

    return (
        <div className="social-media">
            <div onClick={() => handleSignIn(googleProvider)} className="social-icon">
                <FontAwesomeIcon icon={faGoogle} />
            </div>
        </div>
    );
};

export default SocialMedia;